// import { useState, useEffect, createContext, useContext } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import Loading from "../components/Loading";
// import { Routes } from "../routes/Routes";

// type ContextState = {
//   user: any | null;
//   setUser: any;
//   token: any | null;
//   setToken: any;
// };

// const initialValues = {
//   user: null,
//   setUser: () => {},
//   token: null,
//   setToken: () => {},
// };

// type IProps = {
//   children: React.ReactElement<any, any> & React.ReactNode;
// };

// export const UserContext = createContext<ContextState>(initialValues);

// export const UserProvider: React.FC<IProps> = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [userLoading, setUserLoading] = useState(true);
//   const [user, setUser] = useState<any | null>(null);
//   const [token, setToken] = useState<any | null>(null);

//   useEffect(() => {
//     const userData = JSON.parse(localStorage.getItem("user") as any);
//     const tokenData = JSON.parse(localStorage.getItem("kafd-app-token") as any);
//     if (!userData || !tokenData) {
//       navigate(Routes.login);
//       setUserLoading(false);
//     } else {
//       if (!user) {
//         setUser(userData);
//         setToken(tokenData);
//         setUserLoading(false);
//       }
//       if (location.pathname === Routes.login) {
//         navigate(Routes.home);
//       }
//     }
//   }, [user, token]);

//   // //if user click the back button after login in.
//   useEffect(() => {
//     if (location.pathname === Routes.login && user) {
//       navigate(Routes.home);
//     }
//   }, [navigate]);

//   return (
//     <UserContext.Provider value={{ user, setUser, token, setToken }}>
//       {userLoading ? <Loading /> : children}
//     </UserContext.Provider>
//   );
// };

// export const useUser = () => useContext(UserContext);

import { useState, useEffect, createContext, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loading from "../components/Loading";
import { Routes } from "../routes/Routes";

type ContextState = {
  token: any | null;
  setToken: any;
};

const initialValues = {
  token: null,
  setToken: () => {},
};

type IProps = {
  children: React.ReactElement<any, any> & React.ReactNode;
};

export const UserContext = createContext<ContextState>(initialValues);

export const UserProvider: React.FC<IProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userLoading, setUserLoading] = useState(true);
  const [token, setToken] = useState<any | null>(null);

  useEffect(() => {
    const tokenData = JSON.parse(localStorage.getItem("kafd-app-token") as any);
    if (!tokenData) {
      navigate(Routes.login);
      setUserLoading(false);
    } else {
      if (!token) {
        setToken(tokenData);
        setUserLoading(false);
      }
      if (location.pathname === Routes.login) {
        navigate(Routes.home);
      }
    }
  }, [token]);

  // //if user click the back button after login in.
  useEffect(() => {
    if (location.pathname === Routes.login && token) {
      navigate(Routes.home);
    }
  }, [navigate]);

  return (
    <UserContext.Provider value={{ token, setToken }}>
      {userLoading ? <Loading /> : children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
